// extracted by mini-css-extract-plugin
export default {"header":"AttendancesList_header__OWyRK","titleHeader":"AttendancesList_titleHeader__0CX-m","icon":"AttendancesList_icon__hjdVZ"};